import { createFileRoute } from "@tanstack/react-router";
import { reviews } from "@/pages/Reviews";
import Reviews from "@/pages/Reviews";

export const Route = createFileRoute("/reviews")({
  head: () => ({
    meta: [
      { title: "Reviews en ervaringen | De Hussel App" },
      { name: "description", content: "Lees wat tennisclubs en spelers zeggen over De Hussel App. Ervaringen met automatische hussel-indelingen bij tennisclubs door heel Nederland." },
      { property: "og:title", content: "Reviews en ervaringen | De Hussel App" },
      { property: "og:description", content: "Lees wat tennisclubs en spelers zeggen over De Hussel App. Ervaringen met automatische hussel-indelingen bij tennisclubs door heel Nederland." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/reviews" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/reviews" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "Reviews en ervaringen | De Hussel App",
          url: "https://dehusselapp.nl/reviews",
          mainEntity: {
            "@type": "Product",
            name: "De Hussel App",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: (
                reviews.reduce((sum, r) => sum + r.stars, 0) / reviews.length
              ).toFixed(1),
              reviewCount: reviews.length,
              bestRating: "5",
            },
            review: reviews
              .filter((r) => r.stars >= 4)
              .slice(0, 5)
              .map((r) => ({
                "@type": "Review",
                reviewRating: { "@type": "Rating", ratingValue: r.stars, bestRating: "5" },
                author: { "@type": "Person", name: r.author },
                reviewBody: r.quote,
              })),
          },
        }),
      },
    ],
  }),
  component: Reviews,
});
